import { PUBLIC_CARRIER_COOKIE } from 'core/domain/Carrier'
import { cookieClient, type CookieClient } from 'core/infra/cookie'

import { TokenExpiredError } from 'auth/errors/TokenExpiredError'
import { UnauthorizedInviteError } from 'auth/errors/UnauthorizedInviteError'
import { isTokenExpiredError } from 'auth/infra/isTokenExpiredError'
import { isUnauthorizedInviteError } from 'auth/infra/isUnauthorizedInviteError'

import { createRfpGuideHttpClient } from '../infra/createRfpGuideHttpClient'
import { ProposalRepository } from '../infra/ProposalRepository'

export type GetProposalFactoryDependencies = {
  repository: ProposalRepository
  cookie: CookieClient
}

export function getProposalFactory({ repository, cookie }: GetProposalFactoryDependencies) {
  return async function getProposalById(
    id: string,
    queryParams: string | null,
    config?: { signal?: AbortSignal }
  ) {
    try {
      const proposal = await repository.getProposalById(id, queryParams, config)

      cookie.setCookie(PUBLIC_CARRIER_COOKIE, proposal.carrier)

      return proposal
    } catch (error) {
      if (isTokenExpiredError(error)) {
        throw new TokenExpiredError()
      }

      if (isUnauthorizedInviteError(error)) {
        throw new UnauthorizedInviteError()
      }

      throw error
    }
  }
}

export function getProposal(
  id: string,
  queryParams: string | null,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createRfpGuideHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const newGetProposal = getProposalFactory({ repository, cookie: cookieClient })
  return newGetProposal(id, queryParams, config)
}
